import * as React from 'react';
import * as classNames from 'classnames';

interface Props {
  recommendationAmount: number;
  recommendationPercents: number[];
}

export function RecommendationHighlight(props: Props) {
  const highlightDivs = props.recommendationPercents.map((amount) => {
    const shouldHighlight = amount === props.recommendationAmount;

    const classes = classNames(
      'bump-split-button__highlight',
      { 'bump-split-button__highlight--active': shouldHighlight },
    );

    return <div className={classes} key={amount} />;
  });

  return (
    <div className="bump-split-button__highlights">
      <div className="bump-split-button__highlight" />
      {highlightDivs}
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/bump/recommendation_hightlight.tsx